import * as React from 'react';
import * as ReactDOM from 'react-dom';

export class HomeView extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            email:null,
            password:null
        }
    }
    render(){
        return <div className="container">
            <div className="row">
                <div className="col-md-12">
                    
                </div>
            </div>
        </div>
    }
}